"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageFileImporter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Permissions = require("../../constants/Permissions");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsExport = require("../../components/DmsExport/DmsExport");
var _DmsFlexContainer = require("../../components/DmsFlexContainer/DmsFlexContainer");
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsButtonGroup = require("../../components/DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../../components/DmsPermissions/DmsPermissions");
var _DmsTableEditButton = require("../../components/DmsTableButton/DmsTableEditButton");
var _DmsTableCreateButton = require("../../components/DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../../components/DmsTableButton/DmsTableDeleteButton");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPageFileImporter Component
 * 
 * @description Component for managing file importers. Displays a DmsPage layout with a DmsAltBox containing a DmsTable to manage file importer records.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageFileImporter />
 * )
 * 
 * @returns {JSX.Element} The File Importer page.
 */
const DmsPageFileImporter = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("UploadDirectory").d("Upload Directory"),
    column_name: "upload_directory",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("MaxSize").d("Max Size"),
    column_name: "max_size",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Types").d("Types"),
    column_name: "types",
    control: 'select',
    url: "/file_type/all",
    properties: {
      column_name: "name",
      text_template: '{name}',
      multiple: true,
      filter: {
        value: 'pk',
        field: 'file_type_pk',
        join: 'file_importer_file_type',
        left: 'file_importer_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: _Permissions.Permissions.CAN_EDIT_FILE_IMPORTER,
    width: "80px",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        row: row,
        table: table,
        title: _reactIntlUniversal.default.get("Update_name", {
          name
        }).d("Update {name}"),
        url: "/file_importer/"
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Delete_name", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsPageFileImporter.DeleteButtonMessage", {
          name
        }).d("The file importer {name} will be deleted. Are you sure about it?"),
        url: "/file_importer/"
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_FILE_IMPORTER
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: header,
    table: table,
    title: _reactIntlUniversal.default.get("CreateFileImporter").d("Create File Importer"),
    url: '/file_importer'
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "File Importer"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Components").d("Components"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    export_table: false,
    ref: table,
    url: '/file_importer/table',
    toolbar: toolbar
  }))));
};
exports.DmsPageFileImporter = DmsPageFileImporter;